export const sorgular = {
    free: {
        baslik: "Ücretsiz Sorgular",
        ikon: "Unlock",
        sorgu: {
            adsoyad: { ad: "Ad Soyad", ikon: "User", alanlar: [{ ad: "ad", etiket: "Ad", tip: "text" }, { ad: "soyad", etiket: "Soyad", tip: "text" }, { ad: "il", etiket: "İl (Opsiyonel)", tip: "text" }] },
            tc: { ad: "TC Kimlik", ikon: "CreditCard", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            aile: { ad: "Aile", ikon: "Users", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            sulale: { ad: "Sülale", ikon: "GitBranch", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
        },
    },
    vip_kisi: {
        baslik: "Kişi Sorguları",
        ikon: "Crown",
        sorgu: {
            adsoyadpro: { ad: "Ad Soyad PRO", ikon: "UserCheck", alanlar: [{ ad: "ad", etiket: "Ad", tip: "text" }, { ad: "soyad", etiket: "Soyad", tip: "text" }, { ad: "il", etiket: "İl", tip: "text" }] },
            tcpro: { ad: "TC PRO", ikon: "FileText", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            soyadililce: { ad: "Soyad İl İlçe", ikon: "MapPin", alanlar: [{ ad: "soyad", etiket: "Soyad", tip: "text" }, { ad: "il", etiket: "İl", tip: "text" }, { ad: "ilce", etiket: "İlçe", tip: "text" }] },
            soyaddogumt: { ad: "Soyad Doğum", ikon: "Cake", alanlar: [{ ad: "soyad", etiket: "Soyad", tip: "text" }, { ad: "dogum", etiket: "Doğum Tarihi", tip: "text" }] },
            dogumtililce: { ad: "Doğum İl İlçe", ikon: "Calendar", alanlar: [{ ad: "dogum", etiket: "Doğum Tarihi", tip: "text" }, { ad: "il", etiket: "İl", tip: "text" }, { ad: "ilce", etiket: "İlçe", tip: "text" }] },
            sulalepro: { ad: "Sülale PRO", ikon: "Network", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            yabanci: { ad: "Yabancı", ikon: "Globe", alanlar: [{ ad: "tc", etiket: "TC/Pasaport No", tip: "text" }] },
        },
    },
    vip_gsm: {
        baslik: "GSM Sorguları",
        ikon: "Smartphone",
        sorgu: {
            gsmtc: { ad: "GSM > TC", ikon: "Phone", alanlar: [{ ad: "gsm", etiket: "GSM Numarası", tip: "text" }] },
            tcgsm: { ad: "TC > GSM", ikon: "Sim", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            operator: { ad: "Operatör", ikon: "Radio", alanlar: [{ ad: "gsm", etiket: "GSM Numarası", tip: "text" }] },
        },
    },
    vip_adres: {
        baslik: "Adres Sorguları",
        ikon: "Home",
        sorgu: {
            adres: { ad: "Adres", ikon: "Map", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            adres2015: { ad: "Adres 2015", ikon: "MapPinned", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            isyeri: { ad: "İşyeri", ikon: "Building2", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
        },
    },
    vip_vesika: {
        baslik: "Vesika",
        ikon: "Camera",
        sorgu: {
            vesika: { ad: "Vesika", ikon: "Image", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
        },
    },
    vip_tapu: {
        baslik: "Tapu Sorguları",
        ikon: "Landmark",
        sorgu: {
            tapu: { ad: "Tapu", ikon: "FileText", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            istanbul: { ad: "İstanbul Tapu", ikon: "Building", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            kocaeli: { ad: "Kocaeli Tapu", ikon: "Building2", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            istadaparsel: { ad: "İst. Ada/Parsel", ikon: "Grid3x3", alanlar: [{ ad: "ada", etiket: "Ada", tip: "text" }, { ad: "parsel", etiket: "Parsel", tip: "text" }, { ad: "ilce", etiket: "İlçe", tip: "text" }] },
            kocaadaparsel: { ad: "Kocaeli Ada/Parsel", ikon: "Grid3x3", alanlar: [{ ad: "ada", etiket: "Ada", tip: "text" }, { ad: "parsel", etiket: "Parsel", tip: "text" }, { ad: "ilce", etiket: "İlçe", tip: "text" }] },
            tapuadaparsel: { ad: "Tapu Ada/Parsel", ikon: "LayoutGrid", alanlar: [{ ad: "ada", etiket: "Ada", tip: "text" }, { ad: "parsel", etiket: "Parsel", tip: "text" }, { ad: "il", etiket: "İl", tip: "text" }, { ad: "ilce", etiket: "İlçe", tip: "text" }] },
            istbolgetapu: { ad: "İst. Bölge Tapu", ikon: "Search", alanlar: [{ ad: "il", etiket: "İl", tip: "text" }, { ad: "ilce", etiket: "İlçe", tip: "text" }, { ad: "mahalle", etiket: "Mahalle", tip: "text" }] },
            kocatapubolge: { ad: "Kocaeli Bölge Tapu", ikon: "MapPinned", alanlar: [{ ad: "ilce", etiket: "İlçe", tip: "text" }, { ad: "mahalle", etiket: "Mahalle", tip: "text" }] },
            tapubolge: { ad: "Tapu Bölge", ikon: "MapPin", alanlar: [{ ad: "il", etiket: "İl", tip: "text" }, { ad: "ilce", etiket: "İlçe", tip: "text" }, { ad: "mahalle", etiket: "Mahalle", tip: "text" }] },
        },
    },
    vip_diger: {
        baslik: "Diğer",
        ikon: "MoreHorizontal",
        sorgu: {
            facebook: { ad: "Facebook", ikon: "Globe", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            okulno: { ad: "Okul No", ikon: "GraduationCap", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
            sigorta: { ad: "Sigorta", ikon: "Shield", alanlar: [{ ad: "tc", etiket: "TC Kimlik No", tip: "text" }] },
        },
    },
    vip_cc: {
        baslik: "CC",
        ikon: "CreditCard",
        sorgu: {
            ccpuan: { ad: "CC Puan", ikon: "CreditCard", alanlar: [{ ad: "cards", etiket: "Kartlar (satır satır)", tip: "textarea" }] },
        },
    },
};

export const serbestSorgular = ["adsoyad", "tc", "aile", "sulale"];

export function sorguBul(kod) {
    for (const katId in sorgular) {
        const kategori = sorgular[katId];
        if (kategori.sorgu[kod]) {
            return { kategori: katId, ...kategori.sorgu[kod] };
        }
    }
    return null;
}
